module.exports = __webpack_public_path__ + "img/sun-setting-03.2a994139.svg";